import styled from "styled-components"

export const ContactPageWrapper = styled.div`
  width: 100%;
  // height: 50rem;
  background-color: #0a172b;
  @media screen and (max-width: 1000px) {
    /* display	: none; */
    height: 100%;
    padding: 1.714285rem;
    box-sizing: border-box;
  }
`
export const ContactPageContainer = styled.div`
  height: 100%;
  width: 77rem;
  margin: 0 auto;
  display: flex;
  padding-top: 5.75rem;
  box-sizing: border-box;
  @media screen and (max-width: 1000px) {
    flex-direction: column;
    width: 100%;
    margin: 0 auto;
    padding-top: 1rem;
  }
`
